<template>
  <v-card>
    <v-card-title class="px-0">
      <v-text-field
        v-model="search"
        type="search"
        append-icon="search"
        label="Search"
        single-line hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        v-if="copyListQuestions.length > 0"
        color="primary"
        class="mr-0"
        @click="downloadQuestions"
      >
          Download questions
        <v-icon class="ml-2">cloud_download</v-icon>        
      </v-btn>
      <v-btn v-if="!round.status && !showcomponentManager"
        color="primary"
        class="mr-0"
        @click="openModalCreateQuestion"
      >
        New question
        <v-icon class="ml-2">question_answer</v-icon>
      </v-btn>
    </v-card-title>
    <v-layout column>
      <v-flex style="overflow: auto">
        <v-data-table
          :headers="headers"
          :items="copyListQuestions"
          v-model="selected"
          class="elevation-1"
          :pagination.sync="pagination"
          item-key="id"
          :search="search"
        >
          <template slot="headerCell" slot-scope="props">
            <span>{{ props.header.text }} </span>
          </template>
          <template slot="items" slot-scope="props">
            <td>
              <div class="d-flex align-center">
                <v-checkbox
                  v-model="props.selected"
                  :disabled="round.status || !showcomponentManager"
                  primary
                  hide-details
                  @input="updateQuestionSelected"
                ></v-checkbox>
              </div>
            </td>
            <td v-html="props.item.title"></td>
            <td>
              <v-text-field
                type="number"
                v-if="props.selected"
                :rules="rules"
                v-model="props.item.order"
                :disabled="showcomponentManager"
                @input="updateOrder(props.item.id, props.item.order)"
              ></v-text-field>
            </td>
            <td>{{ props.item.type }}</td>
            <td>
              <ul>
                <li v-for="option in props.item.options" :key="option.id" v-html="option.title"></li>
              </ul>
            </td>
            <td>
              <div class="text-center" v-if="!showcomponentManager">
                <v-btn class="mr-0" icon @click="openModalEditQuestion(props.item, props.index)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-tooltip bottom>
                  <template slot="activator">
                    <v-btn icon 
                      @click="openModalDestroyQuestion(props.item, props.index)"
                      :disabled="props.selected" 
                      v-if="!round.status">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{props.item.removable || props.selected ? 'Deleted not possible, because the question is associated in other rounds' : 'Delete Question'}}</span>
                </v-tooltip>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    
    <modal-create-question
      :show-modal="showModal.createQuestion"
      :round-id="round.id"
      @close-modal-create="showModal.createQuestion = false"
      @add-question-round="addQuestion"
    ></modal-create-question>

    <modal-edit-question
      v-if="selectedQuestion && showModal.editQuestion"
      :show-modal="showModal.editQuestion"
      :questionId="selectedQuestion.id"
      :index="index"
      @close-modal-edit="showModal.editQuestion = false"
      @update-question="updateQuestion"
    ></modal-edit-question>

    <modal-delete-question
      v-if="selectedQuestion && showModal.deleteQuestion"
      :show-modal="showModal.deleteQuestion"
      :question="selectedQuestion"
      @close-modal-delete="showModal.deleteQuestion = false"
      @delete-question="deleteQuestion"
    ></modal-delete-question>
    
  </v-card>
</template>
<script>
import ModalCreateQuestion from '@/components/client/questions/modals/CreateQuestion.vue';
import ModalDeleteQuestion from '@/components/client/questions/modals/DeleteQuestion.vue';
import ModalEditQuestion from '@/components/client/questions/modals/EditQuestion.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ModalCreateQuestion,
    ModalDeleteQuestion,
    ModalEditQuestion
  },
  props: {
    round: {
      type: Object,
      required: true
    }
  },
  
  data () {
    return {
      search: '',
      questionList: [],
      showModal: {
        deleteQuestion: false,
        createQuestion: false,
        editQuestion: false
      },
      selectedQuestion: null,
      offsetTop: 0,
      selected: [],
      pagination: {
        rowsPerPage: 5
      },
      rules: [
        value => !!value || 'Required.',
        value => (value || '').length <= 2 || 'Max 2 characters',
      ],
      index: null,
      headers: [
        {
          text: null,
          value: false,
          sortable: false
        },
        {
          text: 'Title',
          value: 'title',
          sortable: true
        },
        {
          text: null,
          value: false,
          sortable: true
        },
        {
          text: 'Type',
          value: 'type',
          sortable: true
        },
        {
          text: 'Options',
          value: false,
          sortable: false
        },
        {
          text: 'actions',
          value: false,
          align: 'center',
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters('question', ['questions', 'question']),
    ...mapGetters(['currentUser']),
    showcomponentManager: function () {
      if (this.currentUser.role === 'manager') {
        return true;
      }
      return false;
    },
    copyListQuestions: function () {
      if (this.round.status === true) {
        return this.selected;
      }
      return this.questionList;
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    loadData () {
      let _self = this;
      let url = `rounds/${this.round.id}/questions`;
      window.axios.get(url).then((response) => {
        this.questionList = response.data.data;
        this.selected = this.questionList.filter((question) => {
          return question.id;
        });
      });
    },
    updateQuestionSelected () {
      let questionsIds = this.selected.map(question => {
        return question.id;
      });
      const url = `rounds/${this.round.id}/associate-questions`;
      const payload = {
        questions_ids: questionsIds,
      };

      window.axios.put(url, payload).then(response => {
        this.$emit('update-question-selected', questionsIds);
        this.setSnackbar({
          show: true,
          color: 'green',
          text: 'Questions update'
        });
      });      
    },
    openModalDestroyQuestion (question) {
      this.selectedQuestion = question;
      this.showModal.deleteQuestion = true;
    },
    deleteQuestion () {
      let _self = this;
      this.setLoading(true);
      window.axios.delete('/questions/' + this.selectedQuestion.id)
        .then((response) => {
          this.setLoading(false);
          let indexOfDelete = this.questionList.map((e) => { 
            return e.id; 
          }).indexOf(this.selectedQuestion.id);

          this.questionList.splice(indexOfDelete, 1);

          this.ModalDestroyQuestion = false;
          this.setSnackbar({
            show: true,
            color: 'success',
            text: 'Question deleted Successfully!'
          });

          this.selectedQuestion = null;
        })
        .catch((error) => {
          this.setLoading(false);
          this.setSnackbar({
            show: true,
            color: 'red',
            text: 'Error delete Question!'
          });
        });
    },
    openModalEditQuestion (question, index) {
      this.showModal.editQuestion = true;
      this.selectedQuestion = question;
      this.index = index;
    },
    updateQuestion (value) {
      let indexOfEdit = this.questionList.map((e) => { 
        return e.id; 
      }).indexOf(value.question.id);

      Object.assign(this.questionList[indexOfEdit], {
        id: value.question.id,
        client_id: value.question.client_id,
        options: value.question.options,
        removable: true,
        title: value.question.title,
        total_rounds: value.question.total_rounds
      });
    },
    openModalCreateQuestion () {
      this.showModal.createQuestion = true;
    },
    addQuestion (value) {
      this.questionList.push(value);
      this.selected.push(value);
      this.updateQuestionSelected();
    },
    updateOrder (question_id, value) {
      if (value !== '') {
        let url = 'questions/' + question_id + '/rounds/' + this.round.id + '/update-order/' + value;
        window.axios.get(url).then((response) => {
        });
      }
    },
    downloadQuestions () {
      let url = `questions/rounds/${this.round.id}/download`;
      window.axios({
        url: url,
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `question-round-${this.round.id}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop;
    },
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/questions/QuestionsTable.vue